import { useMemo, type CSSProperties } from "react";
import { cx } from "./fieldContext";
import { encodeQr, type QrErrorLevel } from "./qrEncoder";

export interface QRCodeProps {
  value: string;
  /** Kantenlänge in Pixeln einschließlich Innenabstand (wie Antd, Standard 160). */
  size?: number;
  errorLevel?: QrErrorLevel;
  /** Farbe der Module; Standard Textfarbe des Themes. */
  color?: string;
  bgColor?: string;
  bordered?: boolean;
  className?: string;
  style?: CSSProperties;
  "aria-label"?: string;
  /** Antd-Optionen ohne Wirkung im Kit (immer SVG). */
  type?: "canvas" | "svg";
}

/** QR-Code (Ersatz für Antd `QRCode`) als SVG; gleiche Modulmatrix wie bisher (`qrEncoder.ts`). */
export function QRCode({ value, size = 160, errorLevel = "M", color, bgColor = "transparent", bordered = true, className, style, "aria-label": ariaLabel }: QRCodeProps) {
  const modules = useMemo(() => encodeQr(value, errorLevel), [errorLevel, value]);
  const count = modules.length;
  const path = useMemo(() => {
    let d = "";
    modules.forEach((row, y) => row.forEach((dark, x) => { if (dark) d += `M${x} ${y}h1v1h-1z`; }));
    return d;
  }, [modules]);
  return (
    <div className={cx("ck-qrcode", bordered && "ck-qrcode-bordered", className)} style={{ width: size, height: size, background: bgColor, ...style }} role="img" aria-label={ariaLabel}>
      <svg viewBox={`0 0 ${count} ${count}`} shapeRendering="crispEdges" aria-hidden="true">
        <path d={path} fill={color ?? "currentColor"} />
      </svg>
    </div>
  );
}
